import {
  ALL_ITEMS as MENU_VALIDATION_SCOPE_ALL_ITEMS,
  DISHES as MENU_VALIDATION_SCOPE_DISHES,
  MENU_TITLES as MENU_VALIDATION_SCOPE_MENU_TITLES,
} from '../constants/menu-validation'

const formatMetricCount = value =>
  typeof value === 'number' && Number.isFinite(value)
    ? value.toLocaleString()
    : 'N/A'

const formatMetricPercent = value =>
  typeof value === 'number' && Number.isFinite(value)
    ? `${(value * 100).toFixed(1)}%`
    : 'N/A'

const getMetricRatio = (count, total) =>
  typeof count === 'number' && total > 0 ? count / total : null

const formatMetricPair = (first, second) =>
  first === 'N/A' || second === 'N/A' ? 'N/A' : `${first} (${second})`

const formatCountAndRatio = (count, ratio) =>
  formatMetricPair(formatMetricCount(count), formatMetricPercent(ratio))

const formatRatioAndCount = (ratio, count) =>
  formatMetricPair(formatMetricPercent(ratio), formatMetricCount(count))

const getValidationFieldMetrics = (
  metrics = {},
  scope = MENU_VALIDATION_SCOPE_ALL_ITEMS,
) => {
  if (scope === MENU_VALIDATION_SCOPE_DISHES) {
    return metrics.dishes?.fieldMetrics || {}
  }
  if (scope === MENU_VALIDATION_SCOPE_MENU_TITLES) {
    return metrics.menuTitles?.fieldMetrics || {}
  }

  return metrics.fieldMetrics || metrics.menu?.fieldMetrics || {}
}

export {
  getMetricRatio,
  formatMetricCount,
  formatMetricPercent,
  formatCountAndRatio,
  formatRatioAndCount,
  getValidationFieldMetrics,
}
